import axios from 'axios';

export const getBooks = () => {
	return axios.get(`/books/books.json`).then((res) => {
		return res.data;
	});
};
